import { Drawer } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import {
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_CURTAIN_EDIT,
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_LIGHT_EDIT,
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_SCENES_EDIT,
  GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_THERMOSTAT_EDIT,
} from '../../../constants/GuestRoomExperienceConst';
import GuestRoomExperienceRoomTabRoomAreaContent from './guest-room-experience-room-tab-room-area-content/Guest-Room-Experience-Room-Tab-Room-Area-Content';
import GuestRoomExperienceRoomTabRoomAreaContentCurtainEdit from './guest-room-experience-room-tab-room-area-content/guest-room-experience-room-tab-room-area-content-curtain-edit/Guest-Room-Experience-Room-Tab-Room-Area-Content-Curtain-Edit';
import GuestRoomExperienceRoomTabRoomAreaContentLightEdit from './guest-room-experience-room-tab-room-area-content/guest-room-experience-room-tab-room-area-content-light-edit/Guest-Room-Experience-Room-Tab-Room-Area-Content-Light-Edit';
import GuestRoomExperienceRoomTabRoomAreaContentSceneEdit from './guest-room-experience-room-tab-room-area-content/guest-room-experience-room-tab-room-area-content-scene-edit/Guest-Room-Experience-Room-Tab-room-Area-Content-Scene-Edit';
import GuestRoomExperienceRoomTabRoomAreaContentThermostatEdit from './guest-room-experience-room-tab-room-area-content/guest-room-experience-room-tab-room-area-content-thermostat-edit/Guest-Room-Experience-Room-Tab-Room-Area-Content-Thermostat-Edit';
import './Guest-Room-Experience-Room-Tab-Room-Area.scss';

const GuestRoomExperienceRoomTabRoomArea = (props) => {
  const { areaInfo, roomId, showLoader = () => {} } = props;
  const [roomAreas, setRoomAreas] = useState([]);
  const [state, setState] = useState({
    type: GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_LIGHT_EDIT,
    status: false,
  });

  useEffect(() => {
    if (areaInfo && areaInfo.length) {
      setRoomAreas(areaInfo);
    }
  }, [areaInfo]);

  const onDrawerToggle = (type, status, obj, index, area) => {
    setState({
      type: type,
      status: status,
      obj: obj,
      index: index,
      area: area,
    });
  };

  const toggleDrawer = (open) => (event, reason) => {
    if (
      reason === 'backdropClick' ||
      (event?.type === 'keydown' && (event?.key === 'Tab' || event?.key === 'Shift'))
    ) {
      return;
    }
    setState(open);
  };

  const switchDrawerContent = (state) => {
    switch (state.type) {
      case GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_LIGHT_EDIT:
        return (
          <GuestRoomExperienceRoomTabRoomAreaContentLightEdit
            toggleDrawer={onDrawerToggle}
            content={state.obj}
            area={state.area}
            index={state.index}
            roomId={roomId}
          ></GuestRoomExperienceRoomTabRoomAreaContentLightEdit>
        );

      case GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_THERMOSTAT_EDIT:
        return (
          <GuestRoomExperienceRoomTabRoomAreaContentThermostatEdit
            toggleDrawer={onDrawerToggle}
            content={state.obj}
            area={state.area}
            index={state.index}
            roomId={roomId}
          ></GuestRoomExperienceRoomTabRoomAreaContentThermostatEdit>
        );
      case GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_CURTAIN_EDIT:
        return (
          <GuestRoomExperienceRoomTabRoomAreaContentCurtainEdit
            toggleDrawer={onDrawerToggle}
            content={state.obj}
            area={state.area}
            index={state.index}
            roomId={roomId}
          ></GuestRoomExperienceRoomTabRoomAreaContentCurtainEdit>
        );

      case GUEST_ROOM_EXPERIENCE_ROOM_TAB_ROOM_AREA_SCENES_EDIT:
        return (
          <GuestRoomExperienceRoomTabRoomAreaContentSceneEdit
            toggleDrawer={onDrawerToggle}
            content={state.obj}
            area={state.area}
            index={state.index}
            roomId={roomId}
          ></GuestRoomExperienceRoomTabRoomAreaContentSceneEdit>
        );

      default:
        break;
    }
  };

  return (
    <>
      {roomAreas?.length && (
        <div>
          <Drawer
            anchor={'right'}
            open={state.status}
            onClose={toggleDrawer(false)}
            className='right-drawer'
          >
            {switchDrawerContent(state)}
          </Drawer>
          <div className='row mx-2'>
            <span className='room-area'>{roomAreas?.length} Room Areas</span>
          </div>
          {roomAreas?.length && (
            <div className='row mx-2'>
              {roomAreas?.map((area, key) => (
                <GuestRoomExperienceRoomTabRoomAreaContent
                  key={key}
                  area={area}
                  onDrawerToggle={onDrawerToggle}
                  roomId={roomId}
                  showLoader={showLoader}
                />
              ))}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default GuestRoomExperienceRoomTabRoomArea;
